import { addTranslationForLanguage, setActiveLanguage } from 'react-localize-redux';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { availableLanguages } from '../..';
import * as moment from 'moment/min/moment-with-locales';

export const translationLoadStart = () => {
    return {
        type: actionTypes.TRANSLATION_LOAD_START
    };
};

export const translationLoadSuccess = () => {
    return {
        type: actionTypes.TRANSLATION_LOAD_SUCCESS,
    };
};

export const translationLoadFail = () => {
    return {
        type: actionTypes.TRANSLATION_LOAD_FAIL
    };
};

const localAxiosInstance = axios.create();
const FALLBACK_LANGUAGE = "en";

const getLocaleStrings = (lng) => {
	return localAxiosInstance.get( '/js/locale/'+lng+'.json')
}

const detectBrowserLanguageOrFallback = () => {
    const userLang = navigator.language || navigator.userLanguage;
    if(availableLanguages.find(lang => lang === userLang.split("-")[0].toLowerCase())) {
        return userLang.split("-")[0].toLowerCase();
    }

    return FALLBACK_LANGUAGE;
}

const isDefaultLanguageAvailable = (defaultLanguage) => {
    const lng = defaultLanguage.split("-")[0] //Default language can be in format of de-DE, we only use the first two characters
    if(availableLanguages.find(lang => lang === lng)) {
        return true;
    }
    return false;
}

const getApplicationLanguagefromDefaultLangaugeOrFallback = (defaultLanguage) => {
    const lng = defaultLanguage.split("-")[0] //Default language can be in format of de-DE, we only use the first two characters
    if(isDefaultLanguageAvailable(lng)) {
        return lng
    }

    return detectBrowserLanguageOrFallback();
}

export const translationLoad = (defaultLanguage) => {    
    return async (dispatch) => {
        dispatch(translationLoadStart());
        try {
            let lng = detectBrowserLanguageOrFallback();
            if(defaultLanguage) {
                lng = getApplicationLanguagefromDefaultLangaugeOrFallback(defaultLanguage);
            }
            const localeStrings = await getLocaleStrings(lng);            
            dispatch( addTranslationForLanguage(localeStrings.data,lng) )
            dispatch( setActiveLanguage(lng) )
            moment.locale(lng);
            dispatch( translationLoadSuccess() );
        } catch (error) {
            dispatch( translationLoadFail( error.response ) ); 
        }
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/translationLoad.js